<template>
    <div class="simple_map_wrap korea">
        <div class="simple_title">전국 확진자 현황</div>
        <div class="date">{{ covidBasdtVal }}</div>
        <div class="unit">
            단위: 명
            <br />( ) 숫자는 전일대비 증감 수치
        </div>

        <div class="simple_map">
            <img src="@/assets/images/simple_map_img_kor.svg">
        </div>
        <div class="do_map">
            <div v-for="area in areas" @click.prevent="areaClickEvent(area)"
                 :class="['do_map_sel', area.clazz]">{{ area.name === '합계' ? '전국' : area.name }}
                <animated-number class="cnt"
                                 :duration="animatedDuration" :formatValue="formatToInt"
                                 :value="covidMapData(area.name, 'val9')" />
                <animated-number class="cnt2"
                                   :duration="animatedDuration" :formatValue="formatToIntSub"
                                   :value="covidMapData(area.name, 'val3')" />

            </div>
            <div :class="['do_map_sel', 'pos011']">강남구
                <animated-number class="cnt"
                                 :duration="animatedDuration" :formatValue="formatToInt"
                                 :value="covidGangnamVal" />
                <animated-number class="cnt2"
                                 :duration="animatedDuration" :formatValue="formatToIntSub"
                                 :value="covidGangnamDay" />
            </div>

        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import gripUtil from "@/libs/grip.util";
import { $_TYPE } from '@/confs/common.const.js';
import AnimatedNumber from "animated-number-vue";

export default {
    components: {
        AnimatedNumber,
    },
    data(){
        return {
            animatedDuration: 500,
            areas: [
                {name: '서울', clazz: 'pos01'},
                {name: '부산', clazz: 'pos16'},
                {name: '대구', clazz: 'pos11'},
                {name: '인천', clazz: 'pos03'},
                {name: '광주', clazz: 'pos14'},
                {name: '대전', clazz: 'pos08'},
                {name: '울산', clazz: 'pos15'},
                {name: '세종', clazz: 'pos05'},
                {name: '경기', clazz: 'pos02'},
                {name: '강원', clazz: 'pos04'},
                {name: '충북', clazz: 'pos06'},
                {name: '충남', clazz: 'pos07'},
                {name: '전북', clazz: 'pos12'},
                {name: '전남', clazz: 'pos13'},
                {name: '경북', clazz: 'pos09'},
                {name: '경남', clazz: 'pos10'},
                {name: '제주', clazz: 'pos17'},
                {name: '검역', clazz: 'pos18'},
                {name: '합계', clazz: 'pos00'},
            ],
        }
    },
    computed: {
        ...mapGetters({
            covidGangnamList: 'getCovidGangnamList',
            covidNationalList: 'getCovidNationalList',
        }),
        basdtVal(){
            if(this.covidNationalList.length > 0){
                let basdtVal = this.covidNationalList[0].basdtVal.substring(0, 8);
                return gripUtil.formatDate(basdtVal, 'yyyy-MM-dd');
            }
        },
        covidBasdtVal(){
            if(typeof this.basdtVal !== $_TYPE.UNDEF && this.basdtVal !== ''){
                return this.basdtVal + ' 0시 기준'
            }
        },
        covidNationalMap(){
            return gripUtil.toDict(this.covidNationalList, 'val2');
        },
        covidGangnam(){
            if(this.covidGangnamList.length > 0){
                return this.covidGangnamList[0];
            }
            return {};
        },
        covidGangnamVal(){
            if(typeof this.covidGangnam.val5 !== $_TYPE.UNDEF && this.covidGangnam.val5 !== '') {
                return this.covidGangnam.val5;
            }
            return 0;
        },
        covidGangnamDateMap(){
            let map = {};
            this.covidGangnamList.forEach(d => {
                let key = d.basdtVal.substring(0, 8);
                if(typeof map[key] === $_TYPE.UNDEF){
                    map[key] = d;
                }
            });
            return map;
        },
        covidGangnamDay(){
            if(typeof this.covidGangnam.basdtVal !== $_TYPE.UNDEF && this.covidGangnam.basdtVal !== '') {
                let basdtVal = this.covidGangnam.basdtVal.substring(0, 4) + '-' + this.covidGangnam.basdtVal.substring(4, 6) + '-' + this.covidGangnam.basdtVal.substring(6, 8);

                let basday = new Date(basdtVal);
                let searchDay = new Date(basday - (3600000 * 24 * 1));
                let searchFromDate = searchDay.format('yyyyMMdd');

                if(typeof this.covidGangnamDateMap[searchFromDate] !== $_TYPE.UNDEF){
                    return Number(this.covidGangnam.val5) - Number(this.covidGangnamDateMap[searchFromDate].val5);
                }
            }
            return 0;
        },
    },
    methods: {
        areaClickEvent(areaInfo){
            // console.log( 'areaClickEvent', areaInfo );
        },
        covidMapData(sido, field){
            if(typeof this.covidNationalMap[sido] === $_TYPE.UNDEF || typeof this.covidNationalMap[sido][field] === $_TYPE.UNDEF){
                return 0;
            }
            return this.covidNationalMap[sido][field];
        },
        formatToInt(val){
            return gripUtil.toCurrency(Number(val).toFixed(0));
        },
        formatToIntSub(val){
            return '+(' + gripUtil.toCurrency(Number(val).toFixed(0)) + ')';
        },
    },
}
</script>
